import React from "react";
import Header from "./Header";
import Services from "./Services";
import About from "./About";
import Why from "./Why";
import OurVideo from "./OurVideo";
import HappyClients from "./HappyClients";
import SubHeader from "./SubHeader";
import Blog from "./Blog";
import People from "./People";
import FAQ from "./FAQ";
import AppStore from "./AppStore";
import Number from "./Number";
import Connect from "./Connect";
import Companies from "./Companies";
import Footer from "./Footer";
import MainPage from "./MainPage";

function App() {
  const house = [
    {
      image: (
        <svg
          width="61"
          height="61"
          viewBox="0 0 61 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1_22039)">
            <g clip-path="url(#clip1_1_22039)">
              <g clip-path="url(#clip2_1_22039)">
                <path
                  d="M9.38393 28.5549V51.7835H51.6598V28.5549C51.0004 28.5549 50.3462 28.5619 49.6939 28.5549C48.4104 28.5373 47.4671 27.6292 47.4742 26.4269C47.4812 25.2227 48.4192 24.3358 49.7168 24.3252C50.951 24.3164 52.1852 24.3218 53.4211 24.3235C55.1313 24.3235 55.9388 25.1221 55.9388 26.8165C55.9388 34.8615 55.9388 42.9047 55.9388 50.9496V51.8329C56.5982 51.8329 57.2276 51.8294 57.8571 51.8329C59.3452 51.8417 60.2232 52.7691 60.1633 54.2642C60.0345 57.4624 57.367 60.137 54.1581 60.2869C54.0259 60.2939 53.8936 60.2975 53.7614 60.2975C38.2866 60.2975 22.81 60.3027 7.33518 60.2939C4.32907 60.2939 1.85367 58.3687 1.11316 55.5213C1.05145 55.2868 1.0109 55.0487 0.970348 54.8107C0.651225 52.8995 1.54336 51.8364 3.46162 51.8347C3.98879 51.8347 4.51596 51.8347 5.13658 51.8347V51.0395C5.13658 42.9734 5.13658 34.9073 5.13658 26.8412C5.13658 25.1169 5.92116 24.327 7.62785 24.3252C8.86201 24.3252 10.0962 24.32 11.3322 24.3252C12.6633 24.3341 13.6171 25.2421 13.6013 26.4692C13.5854 27.6681 12.6422 28.5408 11.3392 28.5549C10.7045 28.5619 10.0715 28.5549 9.38564 28.5549H9.38393Z"
                  fill="#FFA229"
                />
                <path
                  d="M20.22 4.76588C20.5867 4.94748 21.1844 5.21194 21.7468 5.53458C22.0765 5.72323 22.3463 5.77083 22.6319 5.49932C22.6478 5.48345 22.6654 5.46935 22.6848 5.46053C23.792 5.01799 24.3827 4.36037 24.2699 3.00985C24.1747 1.85502 25.2025 1.05458 26.4032 1.0493C29.159 1.03695 31.9129 1.03695 34.6687 1.0493C35.9082 1.05458 36.8849 1.91497 36.8232 3.14913C36.7685 4.24048 37.1071 4.84522 38.0944 5.3283C38.7344 5.64213 39.1399 5.6721 39.7359 5.30009C41.2328 4.36742 42.3241 4.67772 43.1968 6.19926C44.4786 8.43309 45.7586 10.6687 47.0333 12.906C47.8197 14.2866 47.5553 15.4643 46.1694 16.1854C45.4184 16.5768 45.2085 17.0263 45.1891 17.8603C45.1662 18.8371 45.406 19.4012 46.3122 19.8579C47.5341 20.4732 47.7915 21.6914 47.1074 22.9009C45.7728 25.2564 44.4293 27.6066 43.0752 29.9533C42.3664 31.1822 41.1745 31.5454 39.9897 30.789C39.2122 30.2918 38.6462 30.2654 37.8229 30.7714C37.0824 31.2263 36.802 31.6546 36.8373 32.5115C36.9008 34.0736 36.0086 34.9023 34.4307 34.904C31.8301 34.9076 29.2295 34.9076 26.6271 34.904C25.0615 34.9023 24.1641 34.0613 24.2346 32.4974C24.2751 31.63 24.06 31.0693 23.212 30.8031C23.0692 30.759 22.9299 30.6674 22.8171 30.5651C22.3904 30.1807 21.9778 30.179 21.5371 30.5439C21.3872 30.6691 21.2003 30.7502 21.0257 30.8454C19.8797 31.4607 18.7125 31.1751 18.0602 30.0555C16.6532 27.6401 15.2621 25.2141 13.8922 22.7775C13.2804 21.6897 13.5889 20.4432 14.7068 19.8878C15.6218 19.433 15.9233 18.8723 15.881 17.8515C15.8475 17.0211 15.6394 16.5627 14.8936 16.1766C13.5343 15.4731 13.2504 14.29 14.0085 12.9572C15.3256 10.6423 16.6585 8.33612 17.972 6.01943C18.4111 5.24543 19.0475 4.81877 20.2165 4.76588H20.22ZM40.3935 26.1203C41.0934 24.8968 41.7722 23.7067 42.4599 22.5043C42.3065 22.4037 42.2201 22.335 42.1231 22.2857C41.0688 21.7409 40.739 20.8911 40.8325 19.7151C40.9313 18.4738 40.8766 17.2168 40.8149 15.9703C40.7673 15.0129 41.0846 14.2989 41.8956 13.7982C42.0791 13.6853 42.2606 13.5689 42.4633 13.4437C41.7616 12.222 41.0864 11.0425 40.4041 9.85589C40.2736 9.90352 40.1837 9.91759 40.1131 9.96345C38.9901 10.7022 38.001 10.51 36.9801 9.67782C36.289 9.11537 35.5008 8.59885 34.6705 8.29734C33.267 7.7878 32.4736 6.97149 32.6023 5.41998C32.6059 5.38825 32.5547 5.35122 32.5424 5.33359H28.4185C28.6582 6.9662 27.8243 7.77194 26.4332 8.285C25.6627 8.57063 24.8958 9.00078 24.2769 9.53678C23.1626 10.5047 22.0659 10.741 20.8071 9.89648C20.7789 9.87885 20.7242 9.89997 20.6361 9.90878C19.9749 11.0636 19.3014 12.2396 18.6156 13.4403C18.8589 13.5954 19.0599 13.7241 19.2608 13.8546C19.9925 14.3306 20.2852 15.0023 20.2641 15.8733C20.2323 17.2749 20.2323 18.6783 20.2641 20.08C20.2835 20.951 19.9891 21.6227 19.2573 22.097C19.0563 22.2274 18.8553 22.3562 18.6138 22.5113C19.3102 23.7243 19.9925 24.9126 20.6854 26.1203C20.9711 25.9705 21.1809 25.8559 21.396 25.7501C22.1805 25.364 22.9052 25.4751 23.6422 25.9317C24.7953 26.6475 25.9659 27.3369 27.1596 27.9822C27.9512 28.4089 28.4079 28.9994 28.4396 29.9022C28.4485 30.1384 28.4608 30.3747 28.4731 30.6268H32.627C32.627 30.3659 32.6235 30.149 32.627 29.9321C32.6482 28.9994 33.1225 28.4 33.9388 27.9646C35.1165 27.3351 36.2678 26.6563 37.3997 25.9476C38.1579 25.4715 38.9002 25.3605 39.7059 25.7642C39.9192 25.8717 40.1308 25.9829 40.3899 26.1186L40.3935 26.1203Z"
                  fill="#FFA229"
                />
                <path
                  d="M25.0086 43.3687C25.9818 44.3242 26.9145 45.1934 27.7925 46.1138C28.9633 47.3391 28.4008 49.275 26.7823 49.6576C26.0418 49.8321 25.3718 49.647 24.8323 49.1145C23.4041 47.7059 21.9796 46.2936 20.5778 44.8585C19.7263 43.9857 19.721 42.7604 20.569 41.8912C21.969 40.456 23.3883 39.0368 24.8235 37.6369C25.6874 36.7941 26.9709 36.8223 27.7943 37.6474C28.6177 38.469 28.6406 39.7455 27.7978 40.6182C26.9127 41.535 25.9853 42.4078 25.005 43.3704L25.0086 43.3687Z"
                  fill="#FFA229"
                />
                <path
                  d="M36.0423 43.3602C35.1184 42.4504 34.265 41.62 33.4259 40.7772C32.4632 39.8111 32.4015 38.5417 33.2619 37.6619C34.1399 36.7645 35.4322 36.8174 36.4267 37.8029C37.7402 39.1076 39.0519 40.4158 40.3548 41.7293C41.3827 42.766 41.3933 43.9578 40.3742 44.9874C39.0413 46.3362 37.7013 47.6762 36.3508 49.0073C35.4216 49.9241 34.1364 49.9505 33.2813 49.0972C32.4244 48.2421 32.4473 46.9551 33.3588 46.0294C34.221 45.1514 35.1025 44.2928 36.0423 43.3584V43.3602Z"
                  fill="#FFA229"
                />
                <path
                  d="M30.5113 11.6277C34.0075 11.6171 36.8725 14.4592 36.8849 17.9484C36.8955 21.4428 34.0533 24.3096 30.5642 24.3219C27.0732 24.3342 24.2011 21.4868 24.1888 18.0013C24.1782 14.5086 27.0239 11.64 30.5113 11.6295V11.6277ZM32.6516 17.9977C32.664 16.8482 31.7243 15.882 30.5765 15.8608C29.4287 15.8397 28.4502 16.7742 28.4219 17.9184C28.392 19.0926 29.3582 20.0852 30.5307 20.0888C31.6785 20.0922 32.6393 19.1455 32.6516 17.9977Z"
                  fill="#FFA229"
                />
              </g>
            </g>
          </g>
          <defs>
            <clipPath id="clip0_1_22039">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.660004 0.669922)"
              />
            </clipPath>
            <clipPath id="clip1_1_22039">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.660004 0.669922)"
              />
            </clipPath>
            <clipPath id="clip2_1_22039">
              <rect
                width="60"
                height="59.2593"
                fill="white"
                transform="translate(0.660004 1.04004)"
              />
            </clipPath>
          </defs>
        </svg>
      ),

      title: "Company Formation",

      info: "Build web-based solutions that enhance customer experience.",
      more: "Learn more",
    },

    {
      image: (
        <svg
          width="61"
          height="61"
          viewBox="0 0 61 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1_22053)">
            <g clip-path="url(#clip1_1_22053)">
              <g clip-path="url(#clip2_1_22053)">
                <path
                  d="M31.8929 41.355C32.0246 41.5009 32.0921 41.5833 32.1664 41.6589C33.9541 43.4769 35.747 45.2898 37.5229 47.1199C37.7643 47.3688 37.9737 47.6796 38.1104 47.9989C38.3416 48.5448 38.1053 49.0238 37.5415 49.1818C37.2072 49.2762 36.8476 49.3208 36.4999 49.3225C30.7618 49.3311 25.0255 49.3311 19.2875 49.3208C18.9313 49.3208 18.5566 49.2538 18.224 49.1268C17.7192 48.9345 17.5403 48.4693 17.7783 47.9766C17.9404 47.6401 18.1649 47.3156 18.4231 47.0478C20.1569 45.2623 21.9058 43.4923 23.6547 41.7223C23.7459 41.6297 23.8827 41.585 23.9991 41.518C23.9653 41.4717 23.9316 41.4253 23.8978 41.379C23.8201 41.3721 23.7425 41.3619 23.6648 41.3619C16.6371 41.3601 9.60764 41.3567 2.57985 41.3584C1.30193 41.3584 0.483169 40.5429 0.481481 39.2347C0.478105 37.257 0.481481 35.2793 0.481481 33.3016C0.481481 24.067 0.481481 14.8342 0.481481 5.59967C0.478105 4.24171 1.27154 3.43654 2.60855 3.43654C9.35272 3.43654 16.0952 3.43654 22.8394 3.43654C29.8232 3.43482 36.8088 3.43311 43.7944 3.43311C46.9478 3.43311 50.1013 3.43482 53.2548 3.43654C54.6104 3.43654 55.4139 4.24858 55.4139 5.61684C55.4139 12.3792 55.4139 19.1399 55.4123 25.9022C55.4123 26.134 55.4359 26.3023 55.6587 26.4585C58.9759 28.8036 60.659 32.0294 60.4649 36.1446C60.291 39.8184 58.5775 42.6683 55.5929 44.7267C55.3937 44.8641 55.3497 44.9722 55.4156 45.1988C56.2631 48.1104 57.0936 51.0272 57.9496 53.9372C58.3142 55.175 58.2095 56.2806 57.2287 57.1974C55.7921 58.5382 53.3831 57.8909 52.8108 55.9905C52.2081 53.9836 51.6392 51.9664 51.0585 49.9526C50.7546 48.8985 50.4491 47.8444 50.1571 46.7868C50.0963 46.5671 50.0152 46.4761 49.7671 46.4709C45.9603 46.3885 42.9841 44.7319 40.8114 41.5592C40.7472 41.4648 40.6088 41.3653 40.5042 41.3635C37.6647 41.3533 34.8236 41.355 31.8912 41.355H31.8929ZM39.179 37.3738C38.7147 33.6844 39.6382 30.4877 42.189 27.88C44.7398 25.2722 47.8764 24.3142 51.4603 24.7709V7.49328H4.41488V37.3755H39.179V37.3738ZM57.0616 35.5557C57.0582 31.468 53.7106 27.9761 49.4446 28.1616C45.5889 28.3281 42.5435 31.5624 42.4928 35.4853C42.4388 39.5781 45.7088 42.9722 49.7603 42.9808C53.8034 42.9894 57.0987 39.6141 57.0616 35.5557Z"
                  fill="#FFA229"
                />
                <path
                  d="M21.0629 22.0718C21.0629 19.2546 21.0629 16.4374 21.0629 13.6201C21.0629 12.6021 21.7719 11.8364 22.7139 11.8381C23.6728 11.8381 24.4105 12.5815 24.4122 13.5893C24.419 19.2117 24.4207 24.8341 24.4122 30.4566C24.4105 31.7613 23.3976 32.5733 22.2429 32.2351C21.5306 32.0274 21.0663 31.3853 21.0646 30.5974C21.0629 27.7561 21.0646 24.9131 21.0646 22.0718H21.0629Z"
                  fill="#FFA229"
                />
                <path
                  d="M33.3541 23.811C33.3541 26.0566 33.3524 28.3038 33.3541 30.5494C33.3541 31.3099 33.0147 31.8644 32.3462 32.1683C31.7014 32.4619 31.0801 32.3452 30.5467 31.8696C30.1145 31.4833 29.9845 30.9683 29.9845 30.3983C29.9879 26.4171 29.9879 22.4376 29.9879 18.4564C29.9879 17.986 29.9828 17.5173 29.9879 17.047C29.998 16.0341 30.7189 15.2598 31.649 15.2564C32.6248 15.2529 33.3473 15.998 33.3507 17.035C33.3558 19.2942 33.3524 21.5518 33.3524 23.811H33.3541Z"
                  fill="#FFA229"
                />
                <path
                  d="M28.8755 25.531C28.8755 27.2357 28.884 28.9405 28.8722 30.6452C28.8671 31.4693 28.3066 32.1165 27.5031 32.2796C26.7552 32.4324 25.9955 32.0461 25.685 31.3114C25.582 31.0693 25.5279 30.7877 25.5279 30.5233C25.5178 27.1619 25.5195 23.8005 25.5246 20.4407C25.5246 19.4175 26.2353 18.6724 27.1891 18.6656C28.1564 18.6587 28.8806 19.4158 28.884 20.451C28.8874 22.1438 28.884 23.8365 28.884 25.5293H28.8755V25.531Z"
                  fill="#FFA229"
                />
                <path
                  d="M16.5709 25.4881C16.5709 23.8091 16.5658 22.1318 16.5726 20.4528C16.5777 19.421 17.2749 18.6794 18.2321 18.6674C19.1926 18.6554 19.9236 19.3747 19.9269 20.4082C19.9404 23.8194 19.9404 27.2306 19.9269 30.6419C19.9236 31.593 19.1386 32.3398 18.2321 32.3157C17.2968 32.2917 16.5878 31.5604 16.5845 30.5973C16.5793 28.8942 16.5845 27.1894 16.5845 25.4864C16.5811 25.4864 16.5777 25.4864 16.5726 25.4864L16.5709 25.4881Z"
                  fill="#FFA229"
                />
                <path
                  d="M12.1059 27.0022C12.1059 25.84 12.1025 24.6795 12.1059 23.5172C12.1092 22.5094 12.8369 21.7317 13.7653 21.73C14.7208 21.73 15.4602 22.506 15.462 23.5275C15.4653 25.8623 15.4653 28.1988 15.462 30.5336C15.4602 31.5551 14.7141 32.3276 13.7552 32.3156C12.8082 32.3036 12.1092 31.5465 12.1059 30.5233C12.1025 29.349 12.1059 28.1748 12.1059 27.0005V27.0022Z"
                  fill="#FFA229"
                />
                <path
                  d="M37.8748 28.9331C37.8748 29.5374 37.9018 30.1434 37.868 30.7477C37.819 31.6232 37.1252 32.2825 36.2693 32.3169C35.4286 32.3512 34.6065 31.7297 34.5643 30.8713C34.4984 29.5546 34.5069 28.2292 34.5693 26.9125C34.6065 26.1021 35.3627 25.5115 36.1832 25.4978C37.0104 25.4841 37.7582 26.0661 37.8444 26.9021C37.9135 27.5734 37.8579 28.2567 37.8579 28.9348C37.8629 28.9348 37.868 28.9348 37.8748 28.9348V28.9331Z"
                  fill="#FFA229"
                />
                <path
                  d="M55.3789 35.2344C55.3975 36.5427 55.1307 37.5177 54.6243 38.426C54.3592 38.9032 53.9963 39.0302 53.6063 38.8019C53.2518 38.5942 53.1657 38.1787 53.4273 37.7358C54.3491 36.1666 54.155 34.1357 53.0036 32.8018C52.6576 32.4018 52.2068 32.0859 51.7713 31.7803C51.3898 31.5125 51.2311 31.152 51.4269 30.788C51.6228 30.4241 52.0245 30.3142 52.4347 30.5494C54.3254 31.6344 55.2793 33.3031 55.3789 35.2344Z"
                  fill="#FFA229"
                />
              </g>
            </g>
          </g>
          <defs>
            <clipPath id="clip0_1_22053">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.47998 0.670166)"
              />
            </clipPath>
            <clipPath id="clip1_1_22053">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.47998 0.670166)"
              />
            </clipPath>
            <clipPath id="clip2_1_22053">
              <rect
                width="60"
                height="55.2632"
                fill="white"
                transform="translate(0.47998 3.03833)"
              />
            </clipPath>
          </defs>
        </svg>
      ),

      title: "Company Secretarial Services",

      info: "Make data-driven decisions and utilize technology to reach business goals.",
      more: "Learn more",
    },
    {
      image: (
        <svg
          width="61"
          height="61"
          viewBox="0 0 61 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1_22071)">
            <g clip-path="url(#clip1_1_22071)">
              <g clip-path="url(#clip2_1_22071)">
                <path
                  d="M30.3716 23.349C29.6732 21.2856 28.9369 19.2329 28.2981 17.1509C28.0274 16.273 27.5889 15.9946 26.6442 15.9999C19.6034 16.0397 12.56 16.0264 5.51919 16.0131C2.40892 16.0078 1.22328 14.817 1.22599 11.7644C1.22599 9.70364 1.2314 7.64027 1.23952 5.57955C1.24494 2.98309 2.51991 1.69945 5.18624 1.68884C10.7192 1.66762 16.2522 1.67027 21.7852 1.67027C32.9865 1.67027 44.1905 1.67823 55.3918 1.68088C58.7078 1.68088 59.8366 2.78153 59.8393 6.02246C59.842 8.03809 59.8529 10.0564 59.8501 12.072C59.8501 14.7401 58.5589 16.0052 55.8033 16.0078C48.8086 16.0158 41.8111 16.0476 34.8164 15.9813C33.582 15.9707 33.0352 16.3526 32.6996 17.4718C32.1068 19.4424 31.3759 21.3758 30.7046 23.3251C30.5936 23.3331 30.4826 23.341 30.3716 23.349Z"
                  fill="#FFA229"
                />
                <path
                  d="M47.8503 59.6702H13.1663C13.3558 56.1747 12.5383 52.6606 14.1165 49.3427C15.9734 45.4388 19.1216 43.1659 23.5366 43.012C28.1952 42.8503 32.8647 42.8635 37.5233 42.9988C43.0428 43.1606 47.4822 47.4464 47.8259 52.833C47.9667 55.0555 47.8503 57.2965 47.8503 59.6702Z"
                  fill="#FFA229"
                />
                <path
                  d="M0.976959 49.4567C1.11231 46.9079 0.947183 44.4574 1.43172 42.1367C2.26276 38.1426 5.87381 35.4215 10.0425 35.326C13.5588 35.2464 17.0806 35.2889 20.5996 35.3207C20.9758 35.3233 21.5714 35.5408 21.6905 35.8166C22.6758 38.0789 24.2783 39.7684 26.4276 41.2085C25.4531 41.2085 24.4732 41.1395 23.5068 41.2191C18.5044 41.6408 14.8284 44.041 12.6168 48.4727C12.2351 49.2392 11.8047 49.4858 10.9602 49.4752C7.72806 49.4275 4.49327 49.4567 0.979666 49.4567H0.976959Z"
                  fill="#FFA229"
                />
                <path
                  d="M34.6674 41.1849C36.768 39.7899 38.3407 38.127 39.3315 35.9124C39.4641 35.618 40.0082 35.329 40.3628 35.3263C43.9739 35.2892 47.5876 35.2043 51.1933 35.3449C56.1118 35.5358 59.8176 39.339 59.9529 44.15C60.0016 45.8474 59.961 47.5474 59.961 49.4464C58.4424 49.4464 56.9996 49.4464 55.5568 49.4464C53.6836 49.449 51.8077 49.5074 49.9372 49.4251C49.4744 49.4039 48.8139 49.0485 48.6163 48.664C45.9987 43.5851 41.7867 41.1451 36.0209 41.1876C35.5688 41.1902 35.1168 41.1876 34.6674 41.1876V41.1849Z"
                  fill="#FFA229"
                />
                <path
                  d="M30.5528 40.0684C26.3543 40.0792 22.9138 36.7533 22.8921 32.6743C22.8732 28.4812 26.265 25.1051 30.5149 25.0892C34.7539 25.0759 38.189 28.4601 38.1728 32.6372C38.1566 36.7428 34.7539 40.0606 30.5555 40.0712L30.5528 40.0684Z"
                  fill="#FFA229"
                />
                <path
                  d="M38.9878 26.5527C39.0149 23.0147 41.8626 20.2856 45.4709 20.3386C49.0197 20.3916 51.7862 23.134 51.7916 26.6056C51.797 30.1304 48.9574 32.8939 45.3491 32.8753C41.7137 32.8568 38.9607 30.1198 38.9878 26.5553V26.5527Z"
                  fill="#FFA229"
                />
                <path
                  d="M22.0721 26.7304C22.0234 30.271 19.1811 32.9364 15.5322 32.8701C11.9861 32.8038 9.24664 30.035 9.28454 26.5553C9.32244 23.0121 12.1702 20.2857 15.7785 20.3387C19.4031 20.3891 22.1236 23.1526 22.0721 26.733V26.7304Z"
                  fill="#FFA229"
                />
                <path
                  d="M8.91641 4.13672L10.2888 6.86313L13.3585 7.30073L11.1361 9.42245L11.6613 12.4167L8.91641 11.0031L6.16887 12.4167L6.69401 9.42245L4.47162 7.30073L7.54128 6.86313L8.91641 4.13672Z"
                  fill="white"
                />
                <path
                  d="M19.9553 4.13672L21.3277 6.86313L24.3974 7.30073L22.1777 9.42245L22.7002 12.4167L19.9553 11.0031L17.2105 12.4167L17.7329 9.42245L15.5132 7.30073L18.5829 6.86313L19.9553 4.13672Z"
                  fill="white"
                />
                <path
                  d="M30.9942 4.13672L32.3693 6.86313L35.439 7.30073L33.2166 9.42245L33.7418 12.4167L30.9942 11.0031L28.2494 12.4167L28.7745 9.42245L26.5521 7.30073L29.6218 6.86313L30.9942 4.13672Z"
                  fill="white"
                />
                <path
                  d="M42.0358 4.13672L43.4082 6.86313L46.4779 7.30073L44.2582 9.42245L44.7806 12.4167L42.0358 11.0031L39.291 12.4167L39.8134 9.42245L37.5937 7.30073L40.6634 6.86313L42.0358 4.13672Z"
                  fill="white"
                />
                <path
                  d="M53.0747 4.13672L54.4498 6.86313L57.5195 7.30073L55.2971 9.42245L55.8222 12.4167L53.0747 11.0031L50.3299 12.4167L50.855 9.42245L48.6326 7.30073L51.7023 6.86313L53.0747 4.13672Z"
                  fill="white"
                />
              </g>
            </g>
          </g>
          <defs>
            <clipPath id="clip0_1_22071">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.809967 0.670166)"
              />
            </clipPath>
            <clipPath id="clip1_1_22071">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.809967 0.670166)"
              />
            </clipPath>
            <clipPath id="clip2_1_22071">
              <rect
                width="60"
                height="58"
                fill="white"
                transform="translate(0.809967 1.67017)"
              />
            </clipPath>
          </defs>
        </svg>
      ),

      title: "Virtual Office Address",

      info: "Foster customer relationships by effectively serving your market.",
      more: "Learn more",
    },
    {
      image: (
        <svg
          width="61"
          height="61"
          viewBox="0 0 61 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1_22093)">
            <g clip-path="url(#clip1_1_22093)">
              <path
                d="M13.8193 52.7868C13.8193 48.8987 13.805 45.3869 13.8422 41.8723C13.8452 41.5838 14.123 41.1791 14.3893 41.032C17.5204 39.2916 20.6743 37.588 24.0832 35.7346C24.0832 37.8484 24.0832 39.7359 24.0832 41.6261C24.0832 42.9873 24.0372 44.3513 24.0974 45.7096C24.1404 46.683 23.7566 47.28 22.8943 47.7272C21.3532 48.5223 19.8492 49.3939 18.1276 50.3419C22.2212 52.5831 26.097 54.7223 29.9985 56.8136C30.2907 56.9692 30.835 56.9098 31.1472 56.7428C34.9772 54.6827 38.7842 52.5831 42.8719 50.3419C41.2392 49.442 39.8183 48.5818 38.3287 47.8601C37.2373 47.331 36.8592 46.6009 36.8878 45.4096C36.9652 42.2827 36.9136 39.153 36.9136 35.7827C40.3311 37.6277 43.5623 39.3652 46.7793 41.1281C46.974 41.2357 47.1602 41.5611 47.1602 41.7875C47.1832 45.336 47.1773 48.8845 47.1773 52.7839C45.7365 51.3097 44.668 52.235 43.5794 52.832C39.7209 54.9431 35.8479 57.023 32.0352 59.2132C30.8922 59.8698 30.0186 59.8075 28.9128 59.1793C25.0084 56.9607 21.0438 54.8497 17.1222 52.6566C16.0938 52.0821 15.1342 51.553 13.8136 52.7868H13.8193Z"
                fill="#FFA229"
              />
              <path
                d="M18.9527 15.6464C15.5324 17.5168 12.3814 19.2317 9.25038 20.9833C8.98397 21.1333 8.71757 21.5465 8.71183 21.8435C8.67173 24.5064 8.68892 27.1692 8.68892 30.0584C9.71443 29.5009 10.5337 28.9349 11.4418 28.6067C12.0433 28.3888 12.9027 28.2558 13.4183 28.5218C16.4748 30.0951 19.4626 31.7986 22.6766 33.5673C19.3108 35.3897 16.1225 37.1244 12.9199 38.8306C12.7137 38.941 12.347 38.9354 12.1379 38.825C8.92095 37.1442 5.71835 35.4378 2.34387 33.6465C2.85377 33.3267 3.16601 33.0353 3.53267 32.9193C5.71835 32.2345 6.39152 30.8139 6.17095 28.5841C5.94464 26.3061 6.21105 23.9828 6.08788 21.6907C6.01053 20.2532 6.56626 19.4892 7.81808 18.8411C11.0092 17.1914 14.1002 15.3492 17.297 13.7107C18.5431 13.0712 19.2392 12.3609 18.9699 10.9206C18.8783 10.4282 18.9556 9.90756 18.9556 9.16333C22.3616 11.0026 25.5957 12.7373 28.8098 14.5087C29.0303 14.6305 29.2022 15.038 29.2022 15.3125C29.228 18.8242 29.2194 22.3359 29.2194 26.0599C25.9337 24.2602 22.7798 22.5736 19.6889 20.7852C19.2822 20.5504 19.0386 19.7948 18.9871 19.2571C18.8811 18.1479 18.9556 17.0216 18.9556 15.652L18.9527 15.6464Z"
                fill="#FFA229"
              />
              <path
                d="M52.3193 30.0891C52.3193 27.231 52.3365 24.6531 52.2992 22.0752C52.2935 21.7157 52.1073 21.1866 51.8351 21.0338C48.6755 19.2511 45.4815 17.5249 42.0527 15.6516C42.0527 17.0098 42.1443 18.1644 42.0126 19.2935C41.9467 19.8595 41.6144 20.615 41.1588 20.8781C38.1425 22.627 35.063 24.2682 31.7888 26.0623C31.7888 22.3044 31.7803 18.7218 31.806 15.1422C31.806 14.9187 32.018 14.5989 32.2243 14.4885C35.4097 12.7652 38.6123 11.0674 41.7948 9.37231C41.9237 9.54775 42.0268 9.62699 42.0154 9.68358C41.5169 12.171 42.7946 13.4104 44.9688 14.4206C47.9222 15.7902 50.695 17.5391 53.574 19.0671C54.525 19.5708 54.9289 20.2047 54.906 21.2913C54.8429 24.1975 54.9489 27.1094 54.8516 30.0156C54.8144 31.17 55.1868 31.8266 56.2266 32.268C56.9599 32.5793 57.6302 33.0377 58.4667 33.5075C58.1201 33.7536 57.8594 33.9772 57.5644 34.1385C54.8258 35.627 52.0872 37.1211 49.3258 38.5727C48.9563 38.768 48.3605 38.9519 48.0539 38.7935C44.8342 37.1239 41.6516 35.3836 38.28 33.5669C41.5342 31.7841 44.5677 30.0721 47.6615 28.479C48.137 28.2328 48.9534 28.3742 49.5091 28.5893C50.4144 28.9402 51.2393 29.5005 52.3135 30.0919L52.3193 30.0891Z"
                fill="#FFA229"
              />
              <path
                d="M60.0194 35.7463C60.0194 39.3882 60.048 42.7188 59.985 46.0466C59.9764 46.5221 59.6441 47.2041 59.2517 47.4304C56.1923 49.1877 53.0813 50.8573 49.7556 52.6797C49.7556 48.8934 49.7441 45.3534 49.7756 41.8105C49.7756 41.5559 50.022 41.1964 50.254 41.0691C53.4251 39.3175 56.6134 37.5941 60.0165 35.7463H60.0194Z"
                fill="#FFA229"
              />
              <path
                d="M11.2498 52.6845C7.93547 50.865 4.86464 49.2209 1.85396 47.4834C1.42428 47.2344 1.03469 46.5298 1.02323 46.026C0.948755 42.7096 0.985995 39.3931 0.985995 35.8616C4.36333 37.6584 7.59745 39.3677 10.8115 41.1136C11.035 41.2353 11.2297 41.6201 11.2326 41.8861C11.2612 45.3894 11.2498 48.8955 11.2498 52.6845Z"
                fill="#FFA229"
              />
              <path
                d="M20.3191 6.95007C23.6392 5.12769 26.8045 3.37041 30.0013 1.66971C30.2993 1.51125 30.8636 1.58482 31.1873 1.75744C34.3383 3.45247 37.4636 5.19278 40.7206 6.98686C37.4264 8.74414 34.2839 10.4448 31.1099 12.0861C30.7748 12.2587 30.179 12.2247 29.8323 12.0437C26.7071 10.4109 23.6105 8.7215 20.3191 6.95007Z"
                fill="#FFA229"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_1_22093">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.660004 0.629883)"
              />
            </clipPath>
            <clipPath id="clip1_1_22093">
              <rect
                width="60"
                height="59.0476"
                fill="white"
                transform="translate(0.660004 1.10645)"
              />
            </clipPath>
          </defs>
        </svg>
      ),

      title: "Annual Compliance Services",

      info: "Turn your ideas into modern products with our design experts.",
      more: "Learn more",
    },
    {
      image: (
        <svg
          width="61"
          height="61"
          viewBox="0 0 61 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1_22107)">
            <g clip-path="url(#clip1_1_22107)">
              <g clip-path="url(#clip2_1_22107)">
                <path
                  d="M6.96566 32.6968C12.7764 35.2727 18.4542 35.2134 23.8773 31.9602C29.2812 28.7183 32.0125 23.7872 32.4418 17.488C32.6368 17.488 32.8362 17.488 33.0356 17.488C36.4869 17.488 39.9382 17.488 43.3906 17.488C44.452 17.488 44.8238 17.9258 44.6233 18.9612C43.3354 25.6376 42.0453 32.3129 40.7562 38.9882C40.718 39.1897 40.6875 39.3923 40.6401 39.5916C40.4937 40.2196 40.1917 40.468 39.5337 40.4737C38.5399 40.4827 37.545 40.4759 36.5511 40.4759C28.0531 40.4759 19.5561 40.4759 11.0581 40.4759C9.96176 40.4759 9.82201 40.3785 9.4513 39.3834C8.6851 37.3224 7.91664 35.2627 7.14932 33.2029C7.09298 33.0529 7.04002 32.9018 6.96566 32.6968Z"
                  fill="#FFA229"
                />
                <path
                  d="M51.4989 15.1974C51.3523 16.0638 51.2138 16.8631 51.0808 17.6647C49.8234 25.2914 48.5648 32.9194 47.3096 40.5462C47.2194 41.0958 47.2047 41.6645 47.0583 42.1985C46.4284 44.4923 44.371 45.99 41.8976 45.99C31.9742 45.9912 22.052 45.99 12.1286 45.99C11.866 45.99 11.6023 45.9811 11.341 45.9957C10.3584 46.0516 9.74881 46.6763 9.7274 47.648C9.71952 48.0208 9.7398 48.3946 9.71952 48.7663C9.67895 49.513 9.16177 50.0089 8.46317 49.9944C7.7612 49.9798 7.28683 49.476 7.2857 48.7059C7.28458 48.0924 7.24401 47.4655 7.34655 46.8666C7.67331 44.9602 9.25529 43.6538 11.2609 43.5698C11.5415 43.5586 11.8232 43.5665 12.1048 43.5665C21.8965 43.5665 31.6881 43.5665 41.4796 43.5665C43.6014 43.5665 44.4994 42.7728 44.834 40.7063C45.607 35.9251 46.4093 31.1495 47.1991 26.3717C47.7703 22.9171 48.3789 19.4681 48.8949 16.0045C49.056 14.9276 49.2487 13.9201 49.9946 13.0805C50.0656 12.9999 50.034 12.7738 49.9788 12.6462C49.5676 11.7047 49.7704 11.033 50.6594 10.5203C52.54 9.43558 54.4228 8.35531 56.3101 7.28064C57.3028 6.71532 58.0588 6.91906 58.6279 7.88738C59.0053 8.53106 59.384 9.17475 59.7502 9.82403C60.2459 10.7039 60.0307 11.4965 59.1474 12.007C57.3321 13.0558 55.5011 14.0768 53.6995 15.147C52.9795 15.5746 52.2966 15.7425 51.4955 15.1951L51.4989 15.1974Z"
                  fill="#FFA229"
                />
                <path
                  d="M22.6164 52.8973C22.6254 55.6254 20.4463 57.8105 17.7127 57.815C14.9702 57.8195 12.7764 55.6556 12.7639 52.9342C12.7516 50.2196 14.9544 48.0098 17.6745 48.0076C20.4124 48.0053 22.6074 50.1759 22.6164 52.8962V52.8973ZM17.7139 55.3848C19.0671 55.3758 20.1724 54.2719 20.1781 52.9242C20.1837 51.5618 19.0468 50.4367 17.6721 50.4446C16.3257 50.4524 15.2034 51.573 15.2034 52.9085C15.2034 54.2776 16.3358 55.3937 17.7139 55.3848Z"
                  fill="#FFA229"
                />
                <path
                  d="M36.764 57.8174C34.0396 57.8129 31.8289 55.6043 31.8435 52.9008C31.8582 50.1917 34.0813 47.9976 36.799 48.0088C39.5213 48.02 41.7207 50.2231 41.7196 52.9344C41.7184 55.6378 39.5021 57.8219 36.764 57.8174ZM39.2655 52.9097C39.261 51.5407 38.1241 50.4291 36.7449 50.4459C35.3974 50.4626 34.292 51.581 34.2942 52.9266C34.2965 54.2688 35.4086 55.3793 36.7618 55.3871C38.1444 55.3961 39.27 54.2822 39.2655 52.9097Z"
                  fill="#FFA229"
                />
                <path
                  d="M0.95459 16.3623C1.32079 12.6726 2.8746 9.6188 5.58672 7.05078C6.63124 8.29897 7.9518 9.12176 9.32871 9.72962C9.06279 11.9607 8.80364 14.1357 8.53772 16.3623H0.95459Z"
                  fill="#FFA229"
                />
                <path
                  d="M9.27327 25.371C7.99214 26.271 6.74931 27.1442 5.43213 28.0699C2.86986 25.6766 1.34084 22.6172 0.94873 18.9297H8.53524C8.78651 21.1271 9.03552 23.3011 9.27327 25.3721V25.371Z"
                  fill="#FFA229"
                />
                <path
                  d="M19.9111 10.6302C20.1274 12.5714 20.337 14.4465 20.5522 16.373H11.0704C11.2891 14.4308 11.5054 12.5098 11.7285 10.5261C14.4823 11.1239 17.1178 11.1653 19.9111 10.6302Z"
                  fill="#FFA229"
                />
                <path
                  d="M19.866 24.6178C17.1471 24.0928 14.5038 24.1196 11.706 24.7443C11.4896 22.8043 11.2767 20.8968 11.0569 18.9343H20.4575C20.4654 20.8218 20.2085 22.6879 19.8649 24.6178H19.866Z"
                  fill="#FFA229"
                />
                <path
                  d="M25.9358 7.94336C28.0664 10.2315 29.334 13.0424 29.689 16.3482C29.5132 16.3694 29.3611 16.4041 29.2078 16.4041C27.2957 16.4075 25.3836 16.3975 23.4715 16.4143C23.0817 16.4176 22.9836 16.2933 22.9453 15.9116C22.7593 14.0611 22.5239 12.2163 22.3267 10.367C22.3087 10.1979 22.3909 9.92255 22.516 9.84978C23.6236 9.2061 24.7515 8.596 25.9347 7.94336H25.9358Z"
                  fill="#FFA229"
                />
                <path
                  d="M25.9235 27.3489C24.6727 26.6089 23.5043 25.9171 22.373 25.2477C22.604 23.1834 22.8384 21.0777 23.0784 18.9307H29.6812C29.3523 22.2084 28.079 25.0115 25.9235 27.3489Z"
                  fill="#FFA229"
                />
                <path
                  d="M12.3979 27.1463C14.7169 26.6269 16.9478 26.6023 19.2521 27.0455C18.7349 28.6296 18.1884 30.1252 17.0481 31.3129C16.2053 32.1917 15.4312 32.1962 14.5873 31.3263C13.4661 30.1711 12.9264 28.709 12.3979 27.1463Z"
                  fill="#FFA229"
                />
                <path
                  d="M12.4541 8.12279C12.8811 6.82086 13.3634 5.63425 14.1533 4.59764C14.3662 4.31777 14.6164 4.05582 14.8891 3.83529C15.5133 3.33042 16.1353 3.29236 16.7167 3.83641C17.2136 4.30098 17.6721 4.84727 18.0023 5.43722C18.4868 6.30368 18.8406 7.2429 19.2789 8.21234C16.9206 8.6478 14.7167 8.62653 12.4541 8.12279Z"
                  fill="#FFA229"
                />
                <path
                  d="M7.59101 5.42369C8.89243 4.85278 10.1927 4.28186 11.4941 3.71094C11.5144 3.7546 11.5347 3.79713 11.5538 3.84079C11.0491 4.97592 10.5431 6.11104 9.97864 7.38162C9.16735 6.81069 8.36397 6.24425 7.56059 5.67893C7.57073 5.59385 7.58087 5.50877 7.59101 5.42482V5.42369Z"
                  fill="#FFA229"
                />
                <path
                  d="M7.57073 29.5736C8.34933 29.0194 9.12905 28.4653 9.93242 27.8933C10.471 29.1359 10.9623 30.2687 11.5324 31.5841C10.1465 30.9763 8.86651 30.4154 7.5865 29.8546C7.58087 29.7617 7.57637 29.6676 7.57073 29.5747V29.5736Z"
                  fill="#FFA229"
                />
                <path
                  d="M23.8851 6.2657C23.1528 6.69109 22.4193 7.11648 21.6812 7.54635C21.1944 6.39219 20.7415 5.31976 20.2885 4.24621C20.3077 4.20255 20.3269 4.15889 20.346 4.11523C21.5302 4.74549 22.7145 5.37574 23.8987 6.00711C23.8941 6.0933 23.8896 6.1795 23.8851 6.2657Z"
                  fill="#FFA229"
                />
                <path
                  d="M20.3764 31.0133C20.8114 29.9543 21.2463 28.8942 21.7218 27.7344C22.4541 28.1587 23.1855 28.5829 23.9167 29.0072C23.9257 29.08 23.9347 29.1527 23.9426 29.2255C22.7742 29.8614 21.6057 30.4972 20.4373 31.1319C20.4169 31.0916 20.3956 31.0525 20.3753 31.0122L20.3764 31.0133Z"
                  fill="#FFA229"
                />
              </g>
            </g>
          </g>
          <defs>
            <clipPath id="clip0_1_22107">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.47998 0.629883)"
              />
            </clipPath>
            <clipPath id="clip1_1_22107">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.47998 0.629883)"
              />
            </clipPath>
            <clipPath id="clip2_1_22107">
              <rect
                width="60"
                height="54.375"
                fill="white"
                transform="translate(0.47998 3.44238)"
              />
            </clipPath>
          </defs>
        </svg>
      ),

      title: "Payroll Services",

      info: "Expand your business across the globe with minimal effort.",
      more: "Learn more",
    },
    {
      image: (
        <svg
          width="61"
          height="61"
          viewBox="0 0 61 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1_22133)">
            <g clip-path="url(#clip1_1_22133)">
              <g clip-path="url(#clip2_1_22133)">
                <path
                  d="M53.9732 47.7918C53.9732 37.7783 53.9732 27.7648 53.9732 17.7513C53.9732 16.6687 53.9657 16.6612 52.882 16.6612C50.8529 16.6612 48.8239 16.6612 46.9203 16.6612C46.9784 15.394 47.0345 14.1658 47.0944 12.863C47.0663 12.8667 47.2216 12.8257 47.3751 12.8257C49.3836 12.8219 51.392 12.8014 53.3986 12.8275C56.0508 12.863 57.8122 14.651 57.8122 17.2977C57.8178 28.5916 57.8141 39.8874 57.8122 51.1814C57.8122 51.3848 57.7936 51.5882 57.7804 51.8253H2.8642V51.0413C2.8642 39.8631 2.8642 28.6849 2.8642 17.5067C2.8642 14.5391 4.57875 12.8257 7.55676 12.8238C13.0429 12.8182 18.531 12.8238 24.0172 12.8238C24.2418 12.8238 24.4683 12.8238 24.8652 12.8238C23.918 14.1359 23.0832 15.3286 22.1959 16.4821C22.0725 16.6425 21.6924 16.6556 21.4305 16.6556C16.8315 16.665 12.2306 16.6612 7.63163 16.6632C6.77435 16.6632 6.70135 16.7303 6.70135 17.5664C6.70135 27.72 6.70135 37.8735 6.70135 48.027C6.70135 48.2099 6.72007 48.391 6.7313 48.6131H53.9732V47.7918Z"
                  fill="#FFA229"
                />
                <path
                  d="M31.7234 5.56339C35.7795 12.9433 39.7739 20.2132 43.815 27.567C41.539 27.7014 39.3752 27.8358 37.2114 27.9571C34.0893 28.1345 30.9672 28.2987 27.8469 28.4834C27.4894 28.504 27.2778 28.4629 27.0795 28.0953C25.4323 25.0454 23.7533 22.0144 22.0593 18.9346C25.2526 14.5168 28.4552 10.0839 31.7234 5.56152V5.56339Z"
                  fill="#FFA229"
                />
                <path
                  d="M18.1154 32.8303C17.7654 33.0188 17.4061 33.2297 17.0317 33.4108C16.2979 33.7654 15.6036 33.6105 15.2143 32.9199C14.0612 30.8743 12.9307 28.8155 11.8225 26.7438C11.4464 26.0402 11.6859 25.3682 12.3747 24.9464C12.7303 24.7299 13.1047 24.5414 13.4623 24.3435C13.2863 23.2759 13.3631 23.1247 14.3045 22.6096C16.021 21.6708 17.7337 20.7282 19.4519 19.7912C20.4159 19.2649 20.8071 19.3676 21.3219 20.3008C22.8136 23.009 24.3036 25.721 25.7861 28.4348C26.2503 29.284 26.1173 29.7338 25.2675 30.2005C23.5324 31.1543 21.7935 32.0968 20.0546 33.045C19.0926 33.5695 18.9503 33.5545 18.1136 32.8303H18.1154Z"
                  fill="#FFA229"
                />
                <path
                  d="M49.0055 27.0332C49.0073 28.1008 48.4627 28.7466 47.5474 29.0042C46.8211 29.2095 46.1024 28.9426 45.6887 28.2446C45.1664 27.3636 44.6948 26.4546 44.2006 25.5569C40.2549 18.3766 36.3074 11.1982 32.3635 4.01608C31.6821 2.77488 31.9891 1.7838 33.1964 1.26679C33.9901 0.927094 34.7986 1.1604 35.2853 1.87525C35.4033 2.04883 35.5005 2.23548 35.6017 2.41839C39.918 10.2706 44.2362 18.1228 48.5469 25.9787C48.7659 26.3781 48.9137 26.8167 49.0073 27.0332H49.0055Z"
                  fill="#FFA229"
                />
                <path
                  d="M20.5657 34.2602C21.9845 33.4837 23.3302 32.7465 24.6592 32.0186C24.7285 32.0541 24.794 32.0634 24.8052 32.0951C25.9339 35.2475 27.933 37.8382 30.1323 40.3C31.3751 41.6906 31.334 41.907 29.7074 42.7955C28.8689 43.2528 28.0303 43.712 27.1898 44.1655C26.6264 44.4697 26.1417 44.3932 25.8216 43.8146C24.0789 40.6603 22.3438 37.4985 20.5637 34.2602H20.5657Z"
                  fill="#FFA229"
                />
                <path
                  d="M44.9831 16.7905C43.8637 14.7486 42.7743 12.7627 41.6719 10.7526C43.1131 10.5304 44.6405 11.3628 45.3612 12.7048C46.0687 14.0226 45.9283 15.7211 44.9812 16.7905H44.9831Z"
                  fill="#FFA229"
                />
                <path
                  d="M59.8843 53.1692H1.09162C0.608696 55.254 1.62507 57.7103 3.50809 59.0541C3.67654 59.1755 3.9517 59.2838 3.98352 59.4368C4.14636 60.217 4.71913 60.146 5.28815 60.146C14.2034 60.146 22.355 60.1442 30.4879 60.1442C38.6208 60.1442 46.7744 60.1442 55.6877 60.146C56.2586 60.146 56.8296 60.217 56.9924 59.4368C57.0242 59.2818 57.2993 59.1755 57.4678 59.0541C59.349 57.7103 60.3672 55.254 59.8843 53.1692Z"
                  fill="#FFA229"
                />
              </g>
            </g>
          </g>
          <defs>
            <clipPath id="clip0_1_22133">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.810059 0.629883)"
              />
            </clipPath>
            <clipPath id="clip1_1_22133">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.810059 0.629883)"
              />
            </clipPath>
            <clipPath id="clip2_1_22133">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.810059 0.629883)"
              />
            </clipPath>
          </defs>
        </svg>
      ),

      title: "Bookkeeping Services",

      info: "Steering user behaviours with creative design, data insights & technology.",
      more: "Learn more",
    },
  ];

  return (
    <div className=" w-full sm:max-w-[95%] mx-auto bg-white ">
      <Header />
      <MainPage />
      <div className=" bg-service flex flex-col items-center text-center pt-14">
        <div className="text-secondary text-sm uppercase tracking-widest">
          Welcome to registerkaro.in
        </div>
        <div className="font-bold text-4xl py-2 pb-8">Explore Our Services</div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 ">
          {house.map((house, index) => (
            <Services key={index} house={house} />
          ))}
        </div>

        <a
          className=" bg-primary text-white px-4 py-2 mt-8 mb-12 transition"
          to="/"
        >
          See All Services
        </a>
      </div>
      <About />
      <Why />
      <OurVideo />
      <HappyClients />
      <SubHeader />
      <Blog />
      <People />
      <FAQ />
      <AppStore />
      <Number />
      <Connect />
      <Companies />
      <Footer />
    </div>
  );
}

export default App;
